import { getTheme } from "@clipboard-health/ui-theme";
import { isDefined } from "@clipboard-health/util-ts";
import { ThemeProvider } from "@mui/material";
import { useGetWorker } from "@src/appV2/Worker/api/useGetWorker";
import { useGetWorkerBadges } from "@src/appV2/WorkerBadges/api/useGetWorkerBadges";

import { useMarkBadgeAsViewed } from "./api/useMarkBadgeAsViewed";
import { isBadgeType } from "./constants";
import { WorkerBadgeModal } from "./Modal";
import { useIsWorkerBadgesEnabled } from "./useIsWorkerBadgesEnabled";

export function WorkerBadgesModalContainer() {
  // Get the worker ID from the worker data
  const { data: worker } = useGetWorker({ enabled: false });
  const isWorkerBadgesEnabled = useIsWorkerBadgesEnabled();

  const { mutate: markBadgeAsViewed } = useMarkBadgeAsViewed();

  const workerId = worker?.userId;
  const { data: badgesResponse } = useGetWorkerBadges(workerId ?? "", {
    enabled: isDefined(workerId) && isWorkerBadgesEnabled,
    refetchOnMount: false,
  });

  // Find the first unseen badge
  const unseenBadge = badgesResponse?.data.find((badge) => !isDefined(badge.attributes.viewedAt));
  const badgeType = unseenBadge?.attributes.name;

  if (!isDefined(badgeType) || !isBadgeType(badgeType)) {
    return null;
  }

  return (
    <ThemeProvider theme={getTheme()}>
      <WorkerBadgeModal
        badgeType={badgeType}
        onClose={() => {
          markBadgeAsViewed({ workerId: workerId ?? "", badgeId: unseenBadge?.id ?? "" });
        }}
      />
    </ThemeProvider>
  );
}
